export default "__VITE_ASSET__WJ7G0xpa__"